import React from 'react';
import {Form} from "react-bootstrap";

function CustomButton(props) {
    return (
        <div className="custom-checkbox">
                <Form.Label htmlFor={`inline-${props.id}-1`}>
                    <Form.Check
                        inline
                        name="group1"
                        type={props.type}
                        id={`inline-${props.id}-1`}
                    />
                    {props.children}
                </Form.Label>
        </div>
    );
}

export default CustomButton;
